"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateGeneratedRepaymentTapeNodes = void 0;
const common_1 = require("@finley-technologies/common");
const dbNodes = __importStar(require("../dbNodes/dbNodes"));
const DELIMITER = '_____';
const validateGeneratedRepaymentTapeNodes = (params) => {
    const { dataTapes, loanTapeTypeMap } = params;
    const errors = [];
    const uniqueLpSlugTape = new Set();
    const uniqueLpAndCfTape = new Set();
    const generatedRepaymentTapeNodes = dataTapes.filter(dbNodes.generatedRepaymentTape.hasArtifactType);
    for (const node of generatedRepaymentTapeNodes) {
        const { loanProductSlug, creditFacilitySlug, artifactSlug } = node;
        if (!loanProductSlug) {
            errors.push(`generatedRepaymentTape:${artifactSlug} is missing loan product slug.`);
            continue;
        }
        const loanTapeType = loanTapeTypeMap[loanProductSlug];
        switch (loanTapeType) {
            case 'masterLoanTape':
            case 'preassignedMasterLoanTape':
                // Guaranteed to have only 1 generated tape per loanProductSlug
                if (uniqueLpSlugTape.has(loanProductSlug)) {
                    errors.push(`generatedRepaymentTape:${artifactSlug} expects single tape for [loanProductSlug:${loanProductSlug}] since related to [loanType:${loanTapeType}]`);
                }
                else {
                    uniqueLpSlugTape.add(loanProductSlug);
                }
                if (creditFacilitySlug) {
                    errors.push(`generatedRepaymentTape:${artifactSlug} with [loanProductSlug:${loanProductSlug}] expects null credit facility slug since related to [loanType:${loanTapeType}]`);
                }
                break;
            case 'preassignedLoanTape': {
                // May have multiple loan tapes per loanProductSlug, so we must also filter by creditFacilitySlug
                if (!creditFacilitySlug) {
                    errors.push(`generatedRepaymentTape:${artifactSlug} with [loanProductSlug:${loanProductSlug}] is "preassigned" but missing credit facility slug`);
                    break;
                }
                const lpCfKey = `${loanProductSlug}${DELIMITER}${creditFacilitySlug}`;
                if (uniqueLpAndCfTape.has(lpCfKey)) {
                    errors.push(`generatedRepaymentTape:${artifactSlug} found duplicate [loanProductSlug:${loanProductSlug}] and [creditFacilitySlug:${creditFacilitySlug}], related to [loanType:${loanTapeType}]`);
                }
                else {
                    uniqueLpAndCfTape.add(lpCfKey);
                }
                break;
            }
            default:
                // Currently assuming all graphs with repayment tapes also configure
                // loan tapes with referenced loan products, so "loanTapeType" should be present.
                // Otherwise, "loanTapeType" could technically be undefined.
                // Can look to relax this if needed in the future.
                // Using unreachable assertion to help drive type compilation error
                return (0, common_1.finleyAssertUnreachable)(loanTapeType);
        }
    }
    return { errors };
};
exports.validateGeneratedRepaymentTapeNodes = validateGeneratedRepaymentTapeNodes;
//# sourceMappingURL=validateGeneratedRepaymentTapes.js.map